module.exports = __webpack_public_path__ + "img/flowPath-item1-off.b27817de.png";